// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/shop/v1/receive_method.proto (package stailer_service_specification.shop.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { enumDesc, fileDesc, messageDesc, tsEnum } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_enum_description } = require("../../../description_support/v1/enum_description_pb");
const { file_description_support_v1_field_description } = require("../../../description_support/v1/field_description_pb");
const { file_google_protobuf_empty } = require("../../../google/protobuf/empty_pb");

/**
 * Describes the file stailer_service_specification/shop/v1/receive_method.proto.
 */
const file_stailer_service_specification_shop_v1_receive_method = /*@__PURE__*/
  fileDesc("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", [file_description_support_v1_enum_description, file_description_support_v1_field_description, file_google_protobuf_empty]);

/**
 * Describes the message stailer_service_specification.shop.v1.ReceiveMethod.
 * Use `create(ReceiveMethodSchema)` to create a new message.
 */
const ReceiveMethodSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_shop_v1_receive_method, 0);

/**
 * Describes the message stailer_service_specification.shop.v1.AvailableDelivery.
 * Use `create(AvailableDeliverySchema)` to create a new message.
 */
const AvailableDeliverySchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_shop_v1_receive_method, 1);

/**
 * Describes the message stailer_service_specification.shop.v1.AvailablePickup.
 * Use `create(AvailablePickupSchema)` to create a new message.
 */
const AvailablePickupSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_shop_v1_receive_method, 2);

/**
 * Describes the enum stailer_service_specification.shop.v1.DeliveryOption.
 */
const DeliveryOptionSchema = /*@__PURE__*/
  enumDesc(file_stailer_service_specification_shop_v1_receive_method, 0);

/**
 * 配達オプションを表します。
 *
 * @generated from enum stailer_service_specification.shop.v1.DeliveryOption
 */
const DeliveryOption = /*@__PURE__*/
  tsEnum(DeliveryOptionSchema);

/**
 * Describes the enum stailer_service_specification.shop.v1.PickupOption.
 */
const PickupOptionSchema = /*@__PURE__*/
  enumDesc(file_stailer_service_specification_shop_v1_receive_method, 1);

/**
 * 店舗受け取りオプションを表します。
 *
 * @generated from enum stailer_service_specification.shop.v1.PickupOption
 */
const PickupOption = /*@__PURE__*/
  tsEnum(PickupOptionSchema);


exports.file_stailer_service_specification_shop_v1_receive_method = file_stailer_service_specification_shop_v1_receive_method;
exports.ReceiveMethodSchema = ReceiveMethodSchema;
exports.AvailableDeliverySchema = AvailableDeliverySchema;
exports.AvailablePickupSchema = AvailablePickupSchema;
exports.DeliveryOptionSchema = DeliveryOptionSchema;
exports.DeliveryOption = DeliveryOption;
exports.PickupOptionSchema = PickupOptionSchema;
exports.PickupOption = PickupOption;
